import * as React from 'react';
import { Dispatch, Action } from 'redux';
import { connect } from 'react-redux';
import { PagesState, TabType } from '../../reducers/pages';
import { canMoveToPrev, canMoveToNext, getExtraNavItem } from '../../helpers/pages';
import { AppStates, Publication, PageAction, getDefaultRendition } from '../../../../..';
import IconButton from '../common/IconButton';
import { getReflowableRendition } from '../../utils/epub';

interface NewPageNavigatorProps {
  readonly dispatch: Dispatch<Action>;
  readonly pages: PagesState;
  readonly publication: Publication;
  readonly hasNav: boolean;
  readonly onTableOfContentsButtonClick?: () => void;
  readonly onTogglePageJumpToolButtonClick?: () => void;
}

const navigatorFrameStyle: React.CSSProperties = {
  padding: '5px',
  background: 'rgba(0, 0, 0, 0.4)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px',
  marginRight: '10px',
  marginBottom: '0px',
  height: '223px',
};

const buttonStyle: React.CSSProperties = {
  background: 'transparent',
  minWidth: '38px',
  width: '38px',
  height: '38px',
};

class PageNavigationToolbar extends React.PureComponent<NewPageNavigatorProps> {
  public render() {
    const { publication, hasNav } = this.props;

    const { dispatch, pages, onTableOfContentsButtonClick,
      onTogglePageJumpToolButtonClick} = this.props;
    const { activeTab } = pages;
    const prevEnabled = canMoveToPrev(pages, publication);
    const nextEnabled = canMoveToNext(pages, publication);

    return (
      <div style={navigatorFrameStyle}>
        <IconButton
          title="前へ"
          ariaLabel="Prev"
          imagePath="images/page-navigator/btn_left"
          style={{ ...buttonStyle, margin: '5px' }}
          svgStyle={buttonStyle}
          disabled={!prevEnabled}
          onClick={() => { if (prevEnabled) PageAction.showPrevPage(activeTab, dispatch); }} />
        <IconButton
          title="もくじ"
          disabled={!hasNav}
          ariaLabel="Table of contents"
          imagePath="images/page-navigator/btn_contents"
          style={{ ...buttonStyle, margin: '5px', marginTop: '15px' }}
          svgStyle={buttonStyle}
          onClick={onTableOfContentsButtonClick} />
        <IconButton
          title="ページ入力"
          ariaLabel="Page jump"
          imagePath="images/page-navigator/btn_point"
          style={{ ...buttonStyle, margin: '5px', marginBottom: '15px' }}
          svgStyle={buttonStyle}
          onClick={onTogglePageJumpToolButtonClick} />
        <IconButton
          title="次へ"
          ariaLabel="Next"
          imagePath="images/page-navigator/btn_right"
          style={{ ...buttonStyle, margin: '5px' }}
          svgStyle={buttonStyle}
          disabled={!nextEnabled}
          onClick={() => { if (nextEnabled) PageAction.showNextPage(activeTab, dispatch); }} />
      </div>
    );
  }
}

const mapStateToProps = (appStates: AppStates) => {
  const { pages, publication } = appStates;
  if (publication === undefined) {
    throw new Error('Unexpected state.');
  }

  const { activeTab, tabs } = appStates.pages;

  const rendition = tabs[activeTab].type === TabType.ReflowablePages
    ? getReflowableRendition(publication)
    : getDefaultRendition(publication);

  const extraNav = getExtraNavItem(pages, publication);
  const hasNav = rendition.toc.length > 0 || extraNav !== null;

  return { pages, publication, hasNav };
};

export default connect(mapStateToProps)(PageNavigationToolbar);
